import React from 'react';
import Libro from './Views/Libro'
import Home from './Views/Home'
import NotFound from './Views/NotFound'
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'

import './App.css'

const App = () => (
	<Router>
		<Switch>
			<Route exact path="/preview/:type/:id/:token" component={Libro} />
			{/* <Route exact path="/preview/:type/:id/:token" component={Fascicolo} /> */}
			{/* <Route exact path="/preview/r/:id" component={Reda} /> */}
			<Route exact path="/" component={Home} />
			{/* <Route component={NotFound} /> */}
		</Switch>
	</Router>
)

export default App
